export default async function validateExamineeTag(value?: string) {
  if (!value || value.trim() === '') {
    return 'Bitte geben Sie die eindeutige ID des Prüflings ein.';
  }
  if (value.trim().length < 4) {
    return 'Bitte geben Sie die eindeutige ID mit mindestens vier Stellen ein.';
  }
  return undefined;
}
